import { Input } from "@progress/kendo-react-inputs";

export const HeightProperty = {
  propertyName: "Height",
  propertyDisplay: "Height",
  propertyType: "number",
  propertyCategory: "Layout",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <div className="k-d-flex">
        <div className="align-columns">
          <Input
            type="number"
            name={"Height"}
            min={0}
            onBlur={(e) => {
              handlePropertyChange({ propName: "Height", propValue: e.target.value });
            }}
            defaultValue={currentPropertyValues?.Height || ""}
          />
        </div>
      </div>
    );
  },
};
